import { useState } from 'react';

const faqs = [
  {
    q: '51爆料网的内容来源可靠吗？',
    a: '51爆料网的内容来自多方渠道，包括赛事内部人士投稿、知情观众提供线索以及公开信息整理。我们的编辑团队会对每一条爆料进行多方交叉验证，在追求速度的同时坚持真实性原则。对于未经充分证实的消息，我们会明确标注"待核实"标签，让读者自行判断。',
  },
  {
    q: '51爆料每日大赛和51吃瓜爆料每日大赛有什么区别？',
    a: '51爆料每日大赛侧重于赛事本身的内幕爆料，包括选手动态、战术泄露、转会消息等硬核内容；而51吃瓜爆料每日大赛更偏向赛事周边的八卦与趣闻，比如选手私下互动、后台花絮、粉丝争议等轻松话题。两者各有侧重，共同构成完整的赛事爆料生态。',
  },
  {
    q: '如何在51爆料网投稿爆料？',
    a: '你可以通过页面上的"投稿爆料"入口联系我们。我们提供邮箱、微信等多种投稿渠道，并承诺严格保护爆料人的个人信息与隐私。投稿内容经编辑团队审核通过后，将在对应板块发布。对于重大独家爆料，我们还会给予相应的奖励。',
  },
  {
    q: '51爆料网的更新频率是怎样的？',
    a: '51爆料网实行全天候更新机制，编辑团队7×24小时轮值监控各大赛事动态。平均每日新增100+条爆料内容，重大赛事期间更新频率会进一步提升。你可以通过首页的"最新快讯"模块实时追踪最新动态，或关注你感兴趣的话题标签获取定向推送。',
  },
  {
    q: '移动端APP有哪些特色功能？',
    a: '51爆料网移动端APP支持实时推送通知，让你第一时间获取重大爆料消息。APP还提供离线缓存阅读、个性化话题订阅、夜间模式等便捷功能。此外，APP用户享有独家内容优先阅读权和参与爆料话题讨论的专属社区入口。',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="section-py bg-background-50">
      <div className="section-container">
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              常见问题
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full flex items-center justify-between gap-4 p-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 font-heading pr-4">
                    {faq.q}
                  </h3>
                  <div className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-colors ${
                    openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className={`ri-${openIndex === idx ? 'subtract' : 'add'}-line text-sm`}></i>
                  </div>
                </button>
                {openIndex === idx && (
                  <div className="px-4 pb-4">
                    <div className="border-t border-background-200/70 pt-3">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}